import { Trans } from 'next-i18next'
import React from 'react'
import styled from '@emotion/styled'
import useConfig from 'modules/config/state/use-config'
import { TEMPLATE_PLACEHOLDERS } from 'utils/constants/misc'

const Wrapper = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.1px;
  text-align: justify;
  gap: 16px;
  display: flex;
  flex-direction: column;

  a {
    color: inherit;
    text-decoration: underline;
    white-space: nowrap;
    font-weight: bold;
  }
`

export default function LegalText() {
  const config = useConfig()
  const orgPrivacyPolicyLink = config.organization?.privacy_policy_url

  // Manually interpolate organization name into config message if it contains placeholder
  const getInterpolatedMessage = () => {
    if (!config.taxDeductibleMessage) return null

    let message = config.taxDeductibleMessage

    // Handle FAQ-style placeholder: {{ Non-profit name }}
    if (message.includes(TEMPLATE_PLACEHOLDERS.NON_PROFIT_NAME)) {
      message = message.replace(
        TEMPLATE_PLACEHOLDERS.NON_PROFIT_NAME,
        config.organization?.name || '',
      )
    }

    return message
  }

  const interpolatedMessage = getInterpolatedMessage()

  return (
    <Wrapper>
      <div>
        <Trans
          i18nKey="termsOfService"
          components={{
            orgPrivacyPolicyLink: <a target="_blank" href={orgPrivacyPolicyLink} />,
            terms: <a target="_blank" href="https://pro.gofundme.com/c/legal/terms/" />,
            privacy: <a target="_blank" href="https://pro.gofundme.com/c/legal/privacy-notice/" />,
          }}
        />
      </div>
      <div>
        {interpolatedMessage ? (
          <span>{interpolatedMessage}</span>
        ) : (
          <Trans
            i18nKey="stepFooter.taxDeductibleMessage"
            values={{
              organizationName: config.organization?.name,
            }}
          />
        )}
      </div>
    </Wrapper>
  )
}
